// EmdgLinkListItem.tsx
import React from 'react';

export interface EmdgLink {
  text: string;
  link: string;
}

const EmdgLinkListItem: React.FC<EmdgLink> = ({ text, link }) => (
  <li>
        <a target="_blank" href={link}>{text}</a>
  </li>
);

export default EmdgLinkListItem;
